'use strict';

/* Fertilizer & Plantprotectant */
import supplyTableFieldsTemplate from './supplyTableFields.html';
import supplyTableSuppliesTemplate from './supplyTableSupplies.html';
import bookingMaskService from '../bookingMaskService';
import cfnBookingSupplyService from './cfnBookingSupplyService';

angular.module('cfn').directive('cfnBookingSupply', cfnBookingSupply);

cfnBookingSupply.$inject = [
  '$log',
  'unitConverter',
  '$timeout',
  'translateFilter',
  'bookingRules',
  'companyFinanceService',
  'CfnDialogService',
  'search.service',
  'userSettingsService',
  'bookingMaskService',
  '$rootScope',
  'cfnBookingSupplyService',
  'cultureSearch.service'
];

function cfnBookingSupply(
  $log,
  unitConverter,
  $timeout,
  translateFilter,
  bookingRules,
  companyFinanceService,
  CfnDialogService,
  searchService,
  userSettingsService,
  bookingMaskService,
  $rootScope,
  cfnBookingSupplyService,
  cultureSearchService
) {
  return {
    restrict: 'E',
    templateUrl: require('./cfnBookingSupply.html'),
    controller: [
      '$scope',
      function ($scope) {
        $scope.isEngland = userSettingsService.getIsoCountryEnum() === 'GBR';
        $scope.supplyTableFieldsTemplate = supplyTableFieldsTemplate;
        $scope.supplyTableSuppliesTemplate = supplyTableSuppliesTemplate;
        $scope.indicationsAllowed = false;
        $scope.selectedCulture = null;
        let resetTimer = null;
        $scope.isNewBooking = !$scope.details.id;
        $scope.initialized = false;
        let bookingData = {};
        $scope.isSowing = false;

        // Remove all Supplies and Fields
        function resetModel() {
          $scope.model = {
            items: [],
            itemsSum: {},
            fields: [],
            indicationValidation: [],
            fieldsSum: {},
            anyLiquid: null, // mind. 1 Mittel mit der Formulierung "flüssig"
            anyPlantProtectant: null // mind. 1 Pflanzenschutzmittel <> "Zusatzstoff"
          };
        }

        resetModel();

        $scope.unitsForUserCountry = function (unit) {
          return unitConverter.isForCountry(
            unit.value,
            userSettingsService.getIsoCountryEnum()
          );
        };

        // if part bookingRules.element.supply from the common booking state object was loaded, copy data into local format
        bookingRules.elements.supply.onLoad = (result) => {
          console.log("bookingRules.elements.supply.onLoad");
          bookingData = result;
          $scope.initialize();  // necessary for template handling
        };

        $scope.initialize = () => {
          console.log("$scope.initialize");

          const result = bookingData;

          if (searchIndex) {
            searchIndex.clearExcludedItems();
          }

          let sysCultureId = null;
          let newItems = [];

          // To keep it simple, just copy all fertilizers and ppas to local list
          angular.forEach(result.supplies, (value) => {
            // Unmapped supplies might have no type / a type of null
            if (value.supplyType === 'Fertilizer' || value.supplyType === 'PlantProtectant' || value.supplyType === null) {
              // init a basic supply
              if (!value.supply) {
                value.supply = {invalid: true, scope: 'UNKNOWN'};
              }

              newItems.push(value);
            }

            $scope.model.items = newItems;

            if (value.indication && value.indication.sysCultureDTO) {
              sysCultureId = value.indication.sysCultureDTO.id;
            }
          });

          $scope.initialized = !!($scope.isNewBooking);

          if (sysCultureId) {
            $scope.initialized = ($scope.selectedCulture && sysCultureId === $scope.selectedCulture.id);

            cultureSearchService.getSysCulture(sysCultureId).then(
              (response) => {
                if (response.data) {
                  $scope.selectedCulture = response.data.sysCulture;
                } else {
                  $scope.selectedCulture = null;
                }
              }
            ).catch((reason) => {
              console.log(reason);
            });
          }

          angular.forEach(result.supplyProportions, (field) => {
            if (field.supplyType === null || field.supplyType === 'Fertilizer' || field.supplyType === 'PlantProtectant') {
                addFieldSupplyProportion(field);
            }
          });

          setFieldSums();
          excludeAllAddedFields();
        };

        /**
         * Adds field.
         * @param newField  new field
         */
        function addFieldSupplyProportion(newField) {
          if (!newField) {
            return;                     // do nothing id new field is undefined
          }

          let newFieldAssetId = newField.asset ? newField.asset.id : newField.assetId;
          let index = _.findIndex($scope.model.fields, (field) => {
            return (field && field.asset ? field.asset.id : field.assetId) === newFieldAssetId;
          });

          if (index < 0) {                // unknown field --> add
            let newSupplyProp = newField;
            
            //add new field by booking mask
            if (newField.asset) {  
              // Create generic supply proportion and associate with field details
              newSupplyProp = {
                assetId: null,
                area: 0,
                amount: 0,
                unit: null,
                name: null,
                number: null,
                supplyType: null 
              }; 
              // assure initial values - we use field data as template for the proportions     
              newSupplyProp.assetId = newField.asset.id || newField.assetId;
              newSupplyProp.area =  newField.area || newField.asset.farmedArea || 0;
              newSupplyProp.name = newField.asset.nameString || newField.name;
              newSupplyProp.number = newField.asset.number || newField.number;
              newSupplyProp.amountPerArea = $scope.model.itemsSum.amountPerArea || 0 ;
              //unclear why we use unit from field 
              newSupplyProp.unit = newField.asset.unit || null;
              $scope.changeAmountPerArea(newSupplyProp);
            }

            newSupplyProp.supplyType = newSupplyProp.supplyType || null; // Associate to generic supply booking

            //that are not the fields - that are the supply proportions
            $scope.model.fields.push(newSupplyProp);
          }
        }
        
        

        // Transform details-data (fieldList, seedList, ...) to BE-Data (assets, products,...)
        bookingRules.elements.supply.onSave = function (result) {
          result.supplies = _.isArray(result.supplies) ? result.supplies : [];
          result.supplyProportions = _.isArray(result.supplyProportions) ? result.supplyProportions : [];

          // add supply
          $scope.model.items.forEach(item => {
            if (item.id) {
              // this is necessary because the id should be inside supply sub-object
              // otherwise presentation layer will throw 500
              delete item.id;
            }

            if ($scope.selectedCulture && item.indication) {
              item.indication.sysCultureDTO = $scope.selectedCulture;
            }

            result.supplies.push(item);
          });

          // add supplyproportions
          if ($scope.model.items.length > 0) {
            $scope.model.fields.forEach(supplyProportion => {
              result.supplyProportions.push(supplyProportion);
            });
          }
        };

        bookingRules.elements.supply.onClear = function () {
          resetModel();
        };

        function excludeAllAddedFields() {
          $scope.model.items.filter(item => {
            // CFNPOC-9834 If imported from ISOXML the supply can be null (if it's not known while importing).
            return item.supply !== null;
          }).forEach(item => searchIndex.excludeFromIndex(item.supply.id));
        }

        $scope.currencySign = companyFinanceService.getCurrencySign();
        $scope.unitConverter = unitConverter;

        $scope.UnitMasterEnum = {
          MASS: translateFilter('fe.unit.group.MASS'),
          LIQUID: translateFilter('fe.unit.group.LIQUID'),
          VOLUME: translateFilter('fe.unit.group.VOLUME'),
          QUANTITY: translateFilter('fe.unit.group.QUANTITY')
        };

        $scope.isSumHigherThanMixture = (field) => {
          if ($scope.model) {
            const diff = $scope.model.itemsSum.amountPerArea - field.amountPerArea;
            let errorTolerance = 0.001;
            let isHigher = diff < 0;

            //comp
            return ($scope.model.anyPlantProtectant
              && $scope.model.items.length > 1
              && Math.abs(diff) > errorTolerance
              && isHigher
            );
          }

          return false;
        };

        $scope.unitsMassOrVolumeEnum = enums.UnitsCapacityEnum.options.map(value => {
            return {
              value: value,
              label: enums.UnitsCapacityEnum[value],
              group: $scope.UnitMasterEnum[unitConverter.getGroup(value)]
            };
          }
        );

        // Ist es ein Dünger?
        // Nur Düngemitteln haben Nährstoffe, ausgenommen Wasser
        $scope.isFertilizer = (item) => {
          return (item.supplyType === 'Fertilizer' && item.supply.type !== 'BASE');
        }

        $scope.isPlantprotectant = (item) => {
          return (item.supplyType === 'PlantProtectant');
        }

        // Synchronisiere gewählte Schläge mit der Aufteilungs-Ansicht
        $scope.$watchCollection('details.fieldList', (newCollection, oldCollection) => {
          if (!newCollection) {
            resetModel(); // if no fields, the items and the other stuff must removed also
            return;
          }

          if (newCollection !== oldCollection) {
            if (newCollection && oldCollection && newCollection.length <= oldCollection.length) {
              $scope.model.fields.splice(0, $scope.model.fields.length);  // remove all fields
            }

            newCollection.forEach(newField => {
                addFieldSupplyProportion(newField);    // add or update
            });
          }
        });

        // Synchronisiere gewählte supplys für Bonitur
        $scope.$watchCollection('details.supplyList', (newCollection, oldCollection) => {
          console.log("$scope.$watchCollection 'details.supplyList'")
          if (oldCollection === newCollection) {
            return;
          }

          // Create a unique key for the map that checks for existance of supplies.
          function supplyKey(row) {
            // A supply is identified by it's id or if it is not mapped by it's name
            // We cannot simply check for row.id because browser can create new rows without ID
            return row.supply ? row.supply.id : row.unmappedSupplyName;
          }

          let oldPpa = {};
          let changed = false;

          // Was haben wir
          $scope.model.items.forEach(item => {
            oldPpa[supplyKey(item)] = true;
          });

          // Was fehlt?
          $scope.details.supplyList.forEach(value => {
            if (value.supplyType === 'Fertilizer' || value.supplyType === 'PlantProtectant') {
              if (!oldPpa[supplyKey(value)]) {
                addDetail(value);
                changed = true;
              }
            }
          });

          if (changed) {
            setAllFieldDefaults();
          }
        });

        /*
         *
         * --- Calculations ---------------------------------------------------------------------------------------
         *
         */

        /**
         * Calculate the sum of all supply items.
         */
        function calcItemSum() {
          // any liquid in the mix?
          $scope.model.anyLiquid = $scope.model.items.some(item => {
            return unitConverter.isVolume(item.unit);
          });

          // mind. 1 Pflanzenschutzmittel <> "Zusatzstoff"
          $scope.model.anyPlantProtectant = $scope.model.items.some(item => {
            return (item.supplyType === 'PlantProtectant' && item.supply.scope !== 'Z');
          });

          $scope.model.itemsSum = {
            unit: undefined,
            amountPerArea: 0,
            amountN: 0,
            amountP2O5: 0,
            amountK2O: 0,
            amountMgO: 0,
            amountMg: 0,
            nutrientUnit: 'MASSPERAREAL_KGPERHA', // Ergebnis ist immer kg/ha
            price: 0      // Preis der Mischung pro Mischungseinheit, als Zwischenergebnis
          };

          if ($scope.model.items.length === 1) {
            $scope.model.itemsSum.unit = $scope.model.items[0].unit;
          } else {
            // determine mixture unit (per ha)
            let units;
            if ($scope.model.anyLiquid) {
              // consider only volume units
              units = $scope.model.items.reduce((volumeUnits, item) => {
                if (unitConverter.isVolume(item.unit)) {
                  volumeUnits.push(item.unit);
                }

                return volumeUnits;
              }, []);
            } else {
              // no liquids, so it's only mass units anyway
              units = $scope.model.items.map((item) => {
                return item.unit;
              });
            }

            // determine the largest of all related units
            $scope.model.itemsSum.unit = unitConverter.max(units);
          }

          $scope.model.items.forEach(item => {
            if (!$scope.model.anyLiquid || unitConverter.isVolume(item.unit)) {
              // ignore any non liquids if at least one liquid
              // Summierung in Zieleinheit der Mischung
              let amountPerAreaInUnit = 0;

              try {
                amountPerAreaInUnit = unitConverter.convertCapacity(item.unit, $scope.model.itemsSum.unit,
                  item.amountPerArea || 0, item.density);
              } catch (e) {
                console.warn(e);
                // Alles, was nicht umgerechnet werden kann, zählt als 0
              }

              $scope.model.itemsSum.amountPerArea += amountPerAreaInUnit;
            }

            $scope.model.itemsSum.price += (item.amountPerArea || 0) * (item.costsGrossPrice || 0);

            if (item.supply && item.supply.nutrientUnit && item.amountPerArea) {
              $scope.model.itemsSum.amountN += unitConverter.calculateNutrientFromAmount(
                item.amountPerArea,
                item.unit,
                item.supply.amountN || 0,
                item.supply.nutrientUnit,
                item.supply.density,
                1,
                'AREAL_HA'
              );

              $scope.model.itemsSum.amountP2O5 += unitConverter.calculateNutrientFromAmount(
                item.amountPerArea,
                item.unit,
                item.supply.amountP2O5 || 0,
                item.supply.nutrientUnit,
                item.supply.density,
                1,
                'AREAL_HA'
              );

              $scope.model.itemsSum.amountK2O += unitConverter.calculateNutrientFromAmount(
                item.amountPerArea,
                item.unit,
                item.supply.amountK2O || 0,
                item.supply.nutrientUnit,
                item.supply.density,
                1,
                'AREAL_HA'
              );

              $scope.model.itemsSum.amountMgO += unitConverter.calculateNutrientFromAmount(
                item.amountPerArea,
                item.unit,
                item.supply.amountMgO || 0,
                item.supply.nutrientUnit,
                item.supply.density,
                1,
                'AREAL_HA'
              );

              $scope.model.itemsSum.amountMg += unitConverter.calculateNutrientFromAmount(
                item.amountPerArea,
                item.unit,
                item.supply.amountMg || 0,
                item.supply.nutrientUnit,
                item.supply.density,
                1,
                'AREAL_HA'
              );
            }
          });

          // Preis der Mischung umrechnen auf Preis pro kg oder l
          if ($scope.model.itemsSum.amountPerArea) {
            $scope.model.itemsSum.price /= $scope.model.itemsSum.amountPerArea;
          } else {
            $scope.model.itemsSum.price = null;
          }

          // Änderungen bei den items erfordern auch eine Neuberechnung der fields
          setFieldSums();
        }

        function calcMixtureRatio(singleValue, sum) {
          return sum !== 0 ? singleValue / sum : 1;
        }

        /**
         * Calculate the sum of all field areas, amounts and prices.
         *
         * @returns {{area: number, amount: number, price: number, amountPerArea: number, pricePerArea: number}}
         */
        function getCalcFieldSums() {
          let fieldsSum = {
            area: 0,
            amount: 0,
            price: 0,
            amountPerArea: 0,
            pricePerArea: 0
          };

          _.each($scope.model.fields, (field) => {
            field.grossPricePerArea = (field.amountPerArea || 0) * $scope.model.itemsSum.price;
            field.grossPrice = (field.amount || 0) * $scope.model.itemsSum.price;

            fieldsSum.area += field.area || 0;
            fieldsSum.amount += field.amount || 0;
            fieldsSum.price += field.grossPrice;
          });

          if (fieldsSum.area > 0) {
            fieldsSum.amountPerArea = fieldsSum.amount / fieldsSum.area;
            fieldsSum.pricePerArea = fieldsSum.price / fieldsSum.area;
          }

          return fieldsSum;
        }

        function setAllFieldNutrients() {
          _.each($scope.model.fields, (field) => {
            $scope.calcFieldNutrients(field);
          });
        }

        // Berechne Nährstoffzugang pro ha bei einem Schlag
        $scope.calcFieldNutrients = (field) => {
          let applyRatio = calcMixtureRatio(field.amountPerArea, $scope.model.itemsSum.amountPerArea);

          field.amountN = $scope.model.itemsSum.amountN * applyRatio;
          field.amountP2O5 = $scope.model.itemsSum.amountP2O5 * applyRatio;
          field.amountK2O = $scope.model.itemsSum.amountK2O * applyRatio;
          field.amountMgO = $scope.model.itemsSum.amountMgO * applyRatio;
          field.amountMg = $scope.model.itemsSum.amountMg * applyRatio;
        };

        function setFieldSums() {
          let fieldsSum = getCalcFieldSums();

          $scope.model.fieldsSum.area = fieldsSum.area;
          $scope.model.fieldsSum.amount = fieldsSum.amount;
          $scope.model.fieldsSum.price = fieldsSum.price;
          $scope.model.fieldsSum.amountPerArea = fieldsSum.amountPerArea;
          $scope.model.fieldsSum.pricePerArea = fieldsSum.pricePerArea;

          setAllFieldNutrients();
        }

        /*
         *
         * --- User Input ---------------------------------------------------------------------------------------
         *
         */

        function checkIfToAdjustSupplyAmountPerArea() {
          // Special rule: Normally, users would have to independently define both the supply-mixture and the amount to be poured on the field,
          // but in case of just a single supply the user does not have to do this. In fact, he is not even presented those mixture fields (display-noned).
          // Therefore: item[0].amountPerArea (first and only part of the mixture) is the same as amountPerArea defined on the field.

          if ($scope.model.items.length === 1 && $scope.model.fields.length > 0) {
            $scope.model.items[0].amountPerArea = getCalcFieldSums().amountPerArea;
          }
        }

        // 13. Änderung der Fläche ändert Menge pro Hektar <-- überholt
        // CFNPOC-8017: Menge/Hektar bleibt konstant
        $scope.changeArea = (field) => {
          field.area = field.area || 0;
          field.amount = field.amountPerArea * field.area;
        };

        // 14. Änderung der Gesamtmenge ändert Menge pro Hektar
        $scope.changeAmount = (field) => {
          field.amount = field.amount || 0;

          if (field.area) {
            field.amountPerArea = field.amount / field.area;
            checkIfToAdjustSupplyAmountPerArea();
          }
        };

        /**
         * OnChange function for a new value from input field for amount of supply per field.
         * This changes the total amount per field and the amount of supply.
         *
         * @param field   the field who has changed (field.amountPerArea is the changed value)
         */
        $scope.changeAmountPerArea = (field) => {
          field.amount = field.amountPerArea * field.area;
          checkIfToAdjustSupplyAmountPerArea();
        };

        $scope.changeTotalAmount = () => {
          let area = $scope.model.fieldsSum.area;
          let totalAmount = $scope.model.fieldsSum.amount;

          let oldMixtureRatio = $scope.model.fieldsSum.amountPerArea;
          let mixtureRatio = (area > 0) ? totalAmount / area : 0;

          _.each($scope.model.fields, (field) => {
            field.amountPerArea = mixtureRatio;
            field.amount = mixtureRatio * field.area;
            $scope.calcFieldNutrients(field);
          });

          _.each($scope.model.items, (item) => {
            // check if a mixture ratio is set, otherwise skip
            if (oldMixtureRatio !== 0) {
              item.amountPerArea = (mixtureRatio / oldMixtureRatio) * item.amountPerArea;
            }
          });
        };

        // 16.	Änderung der Nährstoffmenge ändert Menge pro Hektar
        $scope.changeNutrient = (field, nutrient) => {
          let mixtureNutrientAmount = $scope.model.itemsSum['amount' + nutrient], mixtureAmountPerArea;

          if (mixtureNutrientAmount) {
            mixtureAmountPerArea = $scope.model.itemsSum.amountPerArea;
            field.amountPerArea = field['amount' + nutrient] / mixtureNutrientAmount * mixtureAmountPerArea;
            $scope.changeAmountPerArea(field);  // Auswirkungen der Änderung berechnen
          }
        };

        // Änderungen an Mitteleinheit -> Umrechnung
        $scope.initSupplyUnit = (supply) => {
          supply.oldUnit = supply.unit;
        };

        /**
         * OnChange function for a new value for supply item amount per area.
         * This re-calculate a new sum of supply mixture and set this as new default value for each field also.
         *
         * @param supply    supply item from input field
         */
        $scope.changeSupplyAmount = (supply) => {
          let sum;

          if ($scope.model.items.length > 1) {
            calcItemSum();  // $scope.model.itemsSum will be recalculate
            sum = $scope.model.itemsSum.amountPerArea;
          } else {
            sum = supply.amountPerArea;
          }

          $scope.model.fields.forEach(field => {
            field.amountPerArea = sum;
            field.amount = sum * (field.area || 0);
            $scope.calcFieldNutrients(field);
          });
        };

        // Änderungen an Mittel-Einheit
        $scope.changeSupplyUnit = (supply) => {
          if (unitConverter.isCapacity(supply.unit) && unitConverter.isCapacity(supply.oldUnit)) {
            if (supply.amountPerArea) {
              supply.amountPerArea = unitConverter.convertCapacity(
                supply.oldUnit,
                supply.unit,
                supply.amountPerArea,
                supply.supply.density
              );
            }

            if (supply.costsGrossPrice) {
              supply.costsGrossPrice = unitConverter.convertCapacity(
                supply.unit,
                supply.oldUnit,
                supply.costsGrossPrice,
                supply.supply.density
              );
            }

            supply.oldUnit = supply.unit;
          }

          // CFNPOC-4843: Bei Änderungen des Sollwerts den Wert auf die Schlagaufteilung übertragen
          setAllFieldDefaults();
        };

        // Mittel hinzufügen (OperationSupplyDetail)
        function addDetail(detail) {
          let existsAlready = _($scope.model.items).reduce((memo, item) => {
              return memo === false ? detail.supply.id === item.supply.id : true;
            }, false);

          if (!existsAlready) {
            $scope.model.items.push(detail);
          }

          if (detail.supplyType === 'PlantProtectant') {
            // prepare empty object for possible indication validation
            if (typeof $scope.model.indicationValidation === 'undefined' || !$scope.model.indicationValidation) {
              $scope.model.indicationValidation = [];
            }

            $scope.model.indicationValidation[detail.id] = {
              allowed: false,
              loading: false,
              placeholder: translateFilter('fe.booking.enterIndication')
            };

            getIndicationsBySupply(detail);   // search for indications for the given supply
          }
        }

        //search
        let searchIndex = searchService('booking_supply', { initOnFirstSearch: true })
          .buildIndex({
            fullText: supplyItem => {
              let tags;

              if (supplyItem.supplyType === 'Fertilizer') {
                tags = [supplyItem.number, supplyItem.nameString, enums.FertilizerTypeEnum[supplyItem.type]];
              } else if (supplyItem.supplyType === 'PlantProtectant') {
                tags = [supplyItem.number, supplyItem.nameString,
                  enums.PlantProtectantScopeEnum[supplyItem.sysPlantProtectant_scope],
                  supplyItem.sysPlantProtectant_approvedForFruits];
              }

              tags.push(enums.SupplyTypeEnum[supplyItem.supplyType]);

              return tags;
            }
          });

        $scope.search = searchIndex.fullTextSearch;

        $scope.searchSelected = (selectedItem) => {
          $scope.addItem(selectedItem);
        };

        // Mittel hinzufügen (SupplyDto)
        $scope.addItem = (item) => {
          let newItem = {
            // OperationSupplyDetail defaults: Zero / item settings
            id: item.id,
            amountPerArea: 0,
            unit: item.unit,
            costsGrossPrice: item.costsGrossPrice || 0,
            currencyUnit: item.currencyUnit || 'CURRENCY_EURO',
            supplyType: item.supplyType,
            // Supply
            supply: angular.copy(item)
          };

          searchIndex.excludeFromIndex(item.id);

          // Some conversion to match saved format
          newItem.supply.scope = newItem.supply.scope || item.sysPlantProtectant_scope;
          delete newItem.supply.sysPlantProtectant_scope;

          // if invalid first ask to correct
          if (item.invalid) {
            if (item.nameString === null) {
              item.nameString = translateFilter('fe.booking.supply.unknown');
            }

            CfnDialogService.showAckDialog(
              translateFilter('fe.booking.gotoCore.title', null, item.nameString),
              translateFilter('fe.booking.gotoCore.message', null, item.nameString),
              function () {
                // on ok
                addDetail(newItem);
                $scope.goBackToCore(newItem.supplyType, newItem.id);
              }
            );
          } else {
            addDetail(newItem);
            $scope.changeSupplyAmount(newItem);
          }
        };

        $scope.setFieldDefaults = (field) => {
          // 11. Die Aufwandsmengen, -preise und Nährstoffe für die einzelnen Schläge werden auf der
          // Basis des Sollwertes und der aktuellen Schlagfläche vorgeschlagen

          field.amountPerArea = $scope.model.itemsSum.amountPerArea;
          field.amount = $scope.model.itemsSum.amountPerArea * (field.area || 0);
          // Preise werden sowieso berechnet

          $scope.calcFieldNutrients(field);
        };

        function setAllFieldDefaults() {
          $scope.model.fields.forEach(field => {
            $scope.setFieldDefaults(field);
          });
        }

        // Remove supply-item from items-Array
        $scope.removeItem = (item) => {
          let i;
          for (i = $scope.model.items.length - 1; i >= 0; i -= 1) {
            if ($scope.model.items[i] === item) {
              $scope.model.items.splice(i, 1);
            }
          }

          setAllFieldDefaults();  // Apply new mixture amount

          // CFNPOC-9834 If imported from ISOXML the supply can be null (if it's not known while importing).
          if (item.supply !== null) {
            //add back to the search
            searchIndex.undoExcludeFromIndex(item.supply.id);
          }
        };

        // fill the object sent to server with data of this table
        $scope.$on('prepareSave', function (evt, section, activityName, details) {
          // OperationSupplyDetails
          $scope.model.items.forEach(value => {
            details.supplies.push(value);
          });

          // OperationSupplyProportions
          $scope.model.fields.forEach(prop => {
            details.supplyProportions.push(prop);
          });
        });

        function setPreHarvestIntervalToNullIfNaN(supply) {
          // check if preHarvestInterval is null or NaN
          // reminder: NaN is the only JavaScript value that is treated as unequal to itself
          const preHarvestIntervalIsNaN = supply.preHarvestInterval !== supply.preHarvestInterval;
        if (preHarvestIntervalIsNaN) {
          supply.preHarvestInterval = null;
        }
      }

        $scope.getMaxDose = (indicationItem, item) => {
          if (indicationItem) {
            $scope.model.indicationValidation[item.id].loading = true;
            bookingMaskService.getMaxDose(item.supply.id,
              cfnBookingSupplyService.getCropPrincipalId($scope.$parent, $scope.model, $scope.selectedCulture),
              cfnBookingSupplyService.getEppoCode($scope.$parent, $scope.model, $scope.selectedCulture),
              indicationItem.code
            ).then(response => {
                // merge the existing indication data with the max dose response
                let result = cfnBookingSupplyService.mergeObjects(indicationItem, response);
                item.preHarvestInterval = indicationItem.preHarvestInterval;
                indicationItem.preHarvestInterval = undefined;
                setPreHarvestIntervalToNullIfNaN(item);

                if (!cfnBookingSupplyService.compareUnits(item, result)) {
                  let message = translateFilter(`fe.indication.info.no.matching.units`, null, item.supply.nameString);

                  $rootScope.alertController.addTemporaryAlertWithCustomTimer(message, 'info', null, 8000);
                }

                if(result.notification) {
                  $rootScope.alertController.addTemporaryAlertWithCustomTimer(result.notification.message,'info',
                    null, 8000);
                }

                return result;
              },error => {
                $log.error('getMaxDose failed', error);

                let message = translateFilter('fe.indication.info.no.max.dose.found');
                $rootScope.alertController.addTemporaryAlertWithCustomTimer(message, 'info',null, 8000);
              }
            ).finally(() => {
              $scope.model.indicationValidation[item.id].loading = false;
            });
          }
        };

        // Returns fertilizer-ID for Amazone-Duengeservice
        function checkForFertilizer() {
          let fertilizer = [];
          $scope.model.items.forEach(value => {
            if ($scope.isFertilizer(value)) {
              fertilizer.push(value.supply.id);
            }
          });

          // Amazone-DuengeService: Einen Duenger oder keinen!
          if (fertilizer.length === 1) {
            $scope.details.fertilizerId = fertilizer[0];
          } else {
            $scope.details.fertilizerId = null;
          }
        }

        // Check for possible indication ids and get the details
        // for each indication from backend
        function checkIfIndicationsAllowed() {
          $scope.indicationsAllowed = !!($scope.selectedCulture);
        }

        function getIndicationsForSupplies(items) {
          items.forEach(item => {
            if (item.supplyType === 'PlantProtectant') {
              getIndicationsBySupply(item);
            }
          });
        }

        function getIndicationsBySupply(item) {
          let itemId = angular.copy(item.id);
          let sysSupplyId = angular.copy(item.supply.id);

          if ($scope.selectedCulture) {
            $scope.model.indicationValidation[itemId] = ($scope.model.indicationValidation[itemId]) ? $scope.model.indicationValidation[itemId] : {};
            $scope.model.indicationValidation[itemId].loading = true;

            bookingMaskService.getIndications(sysSupplyId, $scope.selectedCulture.cropPrincipalId)
              .then(response => {
                $scope.indications[itemId] = response;
                $scope.model.indicationValidation[itemId].allowed = true;
                return response;
              }, error => {
                  $log.error('getIndicationsBySupply failed', error);
                let message = translateFilter('fe.indication.info.no.indications.found');
                $rootScope.alertController.addTemporaryAlertWithCustomTimer(message, 'info', null, 8000);
                  $scope.model.indicationValidation[itemId].allowed = false;
                $scope.model.indicationValidation[itemId].placeholder = translateFilter('fe.indication.indications.indeterminate');
              })
              .finally(() => {
                $scope.model.indicationValidation[itemId].loading = false;
              });
          } else {
            // reset latest selection
            if (itemId && $scope.indications[itemId]) {
              delete $scope.indications[itemId];
            }
          }
        }

        function initIndicationForSupply() {
          // this function is called, when directive is completely loaded
          // and all bindings are made. Then we could start to fill the
          // necessary vars and get the indications for the already exiting supplies
          if (typeof $scope.model.items !== 'undefined' && $scope.model.items.length) {
            let items = angular.copy($scope.model.items);
            let plantProtectants = [];

            items.forEach(item => {
              if (item.supplyType === 'PlantProtectant') {
                $scope.model.indicationValidation[item.id] = {
                  allowed: null,
                  loading: true,
                  placeholder: translateFilter('fe.booking.enterIndication')
                };

                plantProtectants.push(item);
              }
            });

            $timeout(() => {
              getIndicationsForSupplies(plantProtectants);
            }, 300);
          }
        }

        $scope.goBackToCore = (content, id) => {
          $scope.controller.goBackToCore(firstLower(content), id);
        };

        $scope.updateIndications = () => {

          if ($scope.selectedCulture===null) {
            $scope.model.items.forEach(item => {
              if (item.supplyType === 'PlantProtectant') {
                item.preHarvestInterval = null;
              }
            });
          }

          if ($scope.initialized) {
            console.log("$scope.updateIndications after initialization");

            $scope.indications = [];
            $scope.model.items.forEach(item => {

              if (item.supplyType === 'PlantProtectant') {

                // prepare empty object for possible indication validation
                if (item.indication) {
                  item.indication = null;
                }

                if (typeof $scope.model.indicationValidation === 'undefined' || !$scope.model.indicationValidation) {
                  $scope.model.indicationValidation = [];
                }

                $scope.model.indicationValidation[item.id] = {
                  allowed: false,
                  loading: false,
                  placeholder: translateFilter('fe.booking.enterIndication')
                };

                // search for indications for the given supply
                getIndicationsBySupply(item);
              }
            });
          } else {
            console.log("$scope.updateIndications before initialization");
            $scope.initialize();
            initIndicationForSupply();
          }
        };

        $scope.$on('bookingmask-field-update', (event, args) => {
          checkIfIndicationsAllowed();
        });

        $scope.$on('bookingmask-culture-changed', (event, args) => {
          // ignore culture from cropOnFields if sowing .... TODO refactor!
          if ($scope.isSowing) {
            return;
          }

          $scope.selectedCulture = (args.cropOfOperation) ? args.cropOfOperation.sysCultureDTO : null;
          $scope.updateIndications();
        });

        $scope.$on('bookingmask-seed-changed', (event, args) => {
          $scope.selectedCulture =
            (args && args.supply && args.supply.sysSeed && args.supply.sysSeed.sysCulture ) ? args.supply.sysSeed.sysCulture : null;

          // ignore culture from cropOnFields if sowing .... TODO refactor!
          $scope.isSowing = true;
          $scope.updateIndications();
        });

        $scope.$on('bookingmask-reset-indication', (event, args) => {
          // reset indications for each supply item in the booking mask
          let message = translateFilter('fe.indication.info.new.indications.needed');
          // prevent multiple fired reset messages
          if (!resetTimer) {
            let resetTimer = 2500;
            $timeout(() => { resetTimer = null; }, resetTimer);

            $rootScope.alertController.addTemporaryAlertWithCustomTimer(message, 'info', null, 8000);
          }

          $scope.model.items.forEach(item => {
            item.indication = null;
            item.preHarvestInterval = null;
          });

          $scope.indications = [];
          $scope.model.indicationValidation = [];
          initIndicationForSupply();
        });

        // Berechnete Werte im Bereich "Mittel"
        $scope.$watch('model.items', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            calcItemSum();
            checkForFertilizer();
            bookingMaskService.fieldUpdate();
          }}, true);

        // Berechnete Werte im Bereich Aufteilung auf Schläge
        $scope.$watch('model.fields', (newFields, oldFields) => {
          if (newFields !== oldFields) {
            setFieldSums();
            bookingMaskService.fieldUpdate();
          }}, true);

        // watch functions to check if data has changed

        function watchDate() {
          $scope.$watch('$parent.details.startDate', (newValue, oldValue) => {
            if (newValue !== oldValue) {
              // we have to watch the date because the crop has possible changed
              $timeout(() => {
                getIndicationsForSupplies($scope.model.items);
              }, 300);
            }
          }, true);
        }

        this.$onInit = () => {
          $timeout(() => {
            watchDate();
          }, 500);
        };
      }
    ]
  };
}
